import React from 'react';
import { Clock, Award } from 'lucide-react';
import type { Perfil, Topico, Subtopico } from '../../../types';

interface TopicAccordionProps {
  effectivePerfil: Perfil;
  effectiveTopico: Topico | undefined;
  selectedSubtopico: Subtopico | null;
  activeStyles: { color: string; bgLight: string; borderLight: string };
  navigate: (path: string) => void;
}

export function TopicAccordion({
  effectivePerfil,
  effectiveTopico,
  selectedSubtopico,
  activeStyles,
  navigate,
}: TopicAccordionProps) {
  return (
    <div style={{
      flex: 1,
      overflowY: 'auto',
      padding: '16px'
    }}>
      {effectivePerfil.topicos.map((topico, tIdx) => (
        <div key={topico.id} style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '0.72rem',
            fontWeight: 700,
            color: topico.id === effectiveTopico?.id ? activeStyles.color : '#94a3b8',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginBottom: '10px',
            paddingLeft: '6px'
          }}>
            {tIdx + 1}. {topico.titulo}
          </h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {topico.subtopicos.map((sub, sIdx) => {
              const isSelected = selectedSubtopico?.id === sub.id;
              return (
                <button
                  key={sub.id}
                  onClick={() => navigate(`/ecad/${sub.id}?perfil=${effectivePerfil.id}&topico=${topico.id}`)}
                  className="sidebar-item"
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '10px',
                    border: '1px solid',
                    borderColor: isSelected ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
                    background: isSelected 
                      ? `linear-gradient(135deg, ${activeStyles.bgLight} 0%, rgba(255, 255, 255, 0.01) 100%)`
                      : 'transparent',
                    color: isSelected ? '#ffffff' : '#cbd5e1',
                    textAlign: 'left',
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    outline: 'none'
                  }}
                >
                  <span style={{ 
                    fontSize: '0.85rem', 
                    fontWeight: isSelected ? 700 : 600,
                    color: isSelected ? '#ffffff' : '#e2e8f0'
                  }}>
                    {tIdx + 1}.{sIdx + 1}. {sub.titulo}
                  </span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.7rem', color: '#94a3b8' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                      <Clock size={10} />
                      {sub.duracao}
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                      <Award size={10} />
                      {sub.dificuldade}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
